import React from "react";
import { hydrate, render } from "react-dom";
import "./scss/style.scss";
import "./scss/global.scss";
import "./mockup-v4/assets/styles/style.scss";
import { BrowserRouter } from "react-router-dom";
import mixpanel from "mixpanel-browser";
import LandingPageApp from "./mockup-v4/landing-page/App";
import { StoreProvider, createStore } from "easy-peasy";
import { createLogger } from "redux-logger";
import model from "./store";
import InactivityTrackerWrapper from "./util/inactivityTrackerWrapper";

mixpanel.init("dba9e8c550ace1ab6b8b1b67fbc52003", { debug: false });
const store = createStore(model, {
  middleware: [createLogger()],
});

const APP = (
  <React.StrictMode>
    <InactivityTrackerWrapper>
      <BrowserRouter>
        <StoreProvider store={store}>
          <LandingPageApp />
        </StoreProvider>
      </BrowserRouter>
    </InactivityTrackerWrapper>
  </React.StrictMode>
);

const rootElement = document.getElementById("root");
if (rootElement.hasChildNodes()) {
  hydrate(APP, rootElement);
} else {
  render(APP, rootElement);
}
